import { useStudies } from '../domains/viewer/Viewer/StudyLoader/useStudies';

const useStudyIds = (): ReadonlyArray<string> => {
  const { priorStudiesIds } = useStudies();
  return priorStudiesIds;
};

export default useStudyIds;
